import L from "./_common.js";
import { createTheme as y } from "../../../_mixins/use-theme.js";
import z from "../../../_styles/common/light.js";
import T from "../../../popover/styles/light.js";
import { changeColor as o } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function j(d) {
  const {
    borderRadius: c,
    textColor2: p,
    textColorDisabled: s,
    inputColor: l,
    inputColorDisabled: b,
    primaryColor: r,
    primaryColorHover: a,
    warningColor: e,
    warningColorHover: n,
    errorColor: i,
    errorColorHover: t,
    borderColor: h,
    iconColor: x,
    iconColorDisabled: g,
    clearColor: C,
    clearColorHover: m,
    clearColorPressed: v,
    placeholderColor: $,
    placeholderColorDisabled: S,
    fontSizeTiny: u,
    fontSizeSmall: f,
    fontSizeMedium: w,
    fontSizeLarge: H,
    heightTiny: W,
    heightSmall: A,
    heightMedium: E,
    heightLarge: D,
    fontWeight: F
  } = d;
  return Object.assign(Object.assign({}, L), {
    fontSizeTiny: u,
    fontSizeSmall: f,
    fontSizeMedium: w,
    fontSizeLarge: H,
    heightTiny: W,
    heightSmall: A,
    heightMedium: E,
    heightLarge: D,
    borderRadius: c,
    fontWeight: F,
    // default
    textColor: p,
    textColorDisabled: s,
    placeholderColor: $,
    placeholderColorDisabled: S,
    color: l,
    colorDisabled: b,
    colorActive: l,
    border: `1px solid ${h}`,
    borderHover: `1px solid ${a}`,
    borderActive: `1px solid ${r}`,
    borderFocus: `1px solid ${a}`,
    boxShadowHover: "none",
    boxShadowActive: `0 0 0 2px ${o(r, {
      alpha: 0.2
    })}`,
    boxShadowFocus: `0 0 0 2px ${o(r, {
      alpha: 0.2
    })}`,
    caretColor: r,
    arrowColor: x,
    arrowColorDisabled: g,
    loadingColor: r,
    // warning
    borderWarning: `1px solid ${e}`,
    borderHoverWarning: `1px solid ${n}`,
    borderActiveWarning: `1px solid ${e}`,
    borderFocusWarning: `1px solid ${n}`,
    boxShadowHoverWarning: "none",
    boxShadowActiveWarning: `0 0 0 2px ${o(e, {
      alpha: 0.2
    })}`,
    boxShadowFocusWarning: `0 0 0 2px ${o(e, {
      alpha: 0.2
    })}`,
    colorActiveWarning: l,
    caretColorWarning: e,
    // error
    borderError: `1px solid ${i}`,
    borderHoverError: `1px solid ${t}`,
    borderActiveError: `1px solid ${i}`,
    borderFocusError: `1px solid ${t}`,
    boxShadowHoverError: "none",
    boxShadowActiveError: `0 0 0 2px ${o(i, {
      alpha: 0.2
    })}`,
    boxShadowFocusError: `0 0 0 2px ${o(i, {
      alpha: 0.2
    })}`,
    colorActiveError: l,
    caretColorError: i,
    clearColor: C,
    clearColorHover: m,
    clearColorPressed: v
  });
}
const M = y({
  name: "InternalSelection",
  common: z,
  peers: {
    Popover: T
  },
  self: j
}), k = M;
export {
  k as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/selection/styles/light.js
// module id = 932
// module chunks = 67